export enum WellKnownSearchOrderStatuses {
    lookupListId = 131000,

    completed = 131005,
    failed = 131003,
    inProgress = 131002,
    submitted = 131001,
}
